
export const catalogConfigs = {


  // Catálogo de Bundles
  bundle: {
    entityName: "Bundle",
    columns: [
      { name: 'uo_desc', label: 'Unidad Operativa', minWidth: 100,  align: 'center' },
      { name: 'name', label: 'Nombre', minWidth: 100 ,  align: 'center'},
      { name: 'description', label: 'Descripción', minWidth: 100 ,  align: 'center'},
      { name: 'actions', label: 'Acciones', minWidth: 100 ,  align: 'center'},
    ],
  },

  // Catálogo de Microcredencial
  microcredential: {
    entityName: "Microcredencial",
    columns: [
      { name: 'name', label: 'Nombre', minWidth: 100,  align: 'center' },
      { name: 'template_poc', label: 'Template pok', minWidth: 100,  align: 'center' },
      { name: 'credential_name', label: 'Tipo de credencial', minWidth: 100 ,  align: 'center'},
      { name: 'actions', label: 'Acciones', minWidth: 100,  align: 'center' },
    ],
  },

  // Catálogo de Insignias
  badge: {
    entityName: "Insignia",
    columns: [
      { name: 'name', label: 'Nombre', minWidth: 100 ,  align: 'center'},
      { name: 'template_poc', label: 'Template pok', minWidth: 100,  align: 'center' },
      { name: 'credential_name', label: 'Tipo de credencial', minWidth: 100 ,  align: 'center'},
      { name: 'actions', label: 'Acciones', minWidth: 100 ,  align: 'center'},
    ],
  },

  // Catálogo de Reglas
  rules: {
    entityName: "Regla",
    columns: [
      { name: 'bundle_desc', label: 'Bundle', minWidth: 100 ,  align: 'center'},
      { name: 'microcredential_desc', label: 'Microcredential', minWidth: 100 ,  align: 'center'},
      { name: 'badge_desc', label: 'Insignia', minWidth: 100 ,  align: 'center'},
      { name: 'assignment_desc', label: 'Tipo asignación', minWidth: 150 ,  align: 'center'},
      { name: 'course_desc', label: 'Unidad', minWidth: 100 ,  align: 'center'},
      { name: 'actions', label: 'Acciones', minWidth: 100 ,  align: 'center'},
    ],
  },
};

// Gestión de Microcredenciales
export const baseRequests = [
  { name: "full_name", label: "Nombre", minWidth: 100, align: 'center',  align: 'center' },
  //{ name: "email", label: "Email", minWidth: 50, align: 'center' ,  align: 'center'},
  { name: "pok_status", label: "Estatus", minWidth: 50, align: 'center',  align: 'center' },
  
];

// Listados de Credenciales 
export const requestsLog = [
  { name: "creation_date_display", label: "Fecha", minWidth: 50,align: "center" },
  { name: "credential_type", label: "Tipo",minWidth: 50, align: "center" },
  { name: "full_name", label: "Nombre", minWidth: 50, align: "center" },
  { name: "pok_status", label: "Estatus",minWidth: 50,  align: "center" },
  //{ name: "course_id", label: "Unidad",minWidth: 50, align: "center" },

];
